export default "__VITE_PUBLIC_ASSET__22aedf28__"